export const contactColumnsConfig = {
  FULL_NAME: "Full Name",
  EMAIL: "Email",
  PHONE: "Phone Number",
  MESSAGE: "Message",
  CREATED_AT: "Created At",
  ACTIONS: "Actions",
};